angular.module('deliverymethods', ['core'])
    .factory('DeliveryMethod', function ($resource) {
        return $resource('/crm/api/delivery-methods/:id', {}, {
            list: {method: 'GET'},
            get: {method: 'GET'},
            table: {method: 'GET', isArray: false, url: '/crm/api/delivery-methods/table'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'}
        });
    })
    .service('DeliveryMethodService', function ($rootScope, modals, DeliveryMethod, $filter) {
        this.editModal = entity => modals.open('app/delivery-method/edit-modal.html', 'DeliveryMethodDialogController', angular.copy(entity), {size: 'md'}, "$ctrl");
        this.addModal = () => {
            let entity = {
                active: true,
                id: null
            };
            return this.editModal(entity);
        };
        this.remove = item => {
            return modals.confirmDelete($filter("localized")(item.name), () => DeliveryMethod.delete({id: item.id}, () => $rootScope.$broadcast('deliverymethod.updated')).$promise);
        };
    })
    .component('deliveryMethodList', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/delivery-method/list.html',
        controller: function ($scope, $state, DeliveryMethodService) {
            this.DeliveryMethodService = DeliveryMethodService;
            this.reset = () => this.filters = {}

            $scope.$on('deliverymethod.updated', () => $state.reload());
        }
    })
    .controller('DeliveryMethodDialogController', function ($timeout, $scope, $rootScope, $uibModalInstance, data, toastr, DeliveryMethod, Language) {
        this.item = data;

        this.cancel = () => $uibModalInstance.dismiss('Canceled');

        this.save = () => {
            let promise;
            if (this.item.id !== null) {
                promise = DeliveryMethod.update(this.item).$promise
            } else {
                promise = DeliveryMethod.save(this.item).$promise
            }
            return promise.then(result => {
                $rootScope.$broadcast('deliverymethod.updated');
                $uibModalInstance.close(result);
                toastr.success("Zapisano");
            })
        };
    })
    .config(function ($stateProvider) {
        $stateProvider.state('deliveryMethodList', {
            parent: 'app',
            url: '/delivery-method?{page:int}&{size:int}&sort&search',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': 'deliveryMethodList'
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (DeliveryMethod, $stateParams) => DeliveryMethod.table(angular.copy($stateParams)).$promise
            }
        });
    });
